<template>


	<div class="stage stage--dcpSdg block_dcp" :style="{ 'background-image': backgroundImage }">
		<div class="header__container">
			<div class="header" style="position: relative" v-html="stageData.header"/>
			
		</div>
		

		<div class="card">
			
			<div class="text" v-html="stageData.story"/>


			<div class="clusters">
				<div class="sdg-cluster" v-for="(cluster , index) in sdgData.clusters">
					<!-- {{sdgData.bestScoredSdgPerCluster[index]}}<br> -->

					<img :src="baseUrl+'media/instances/33/SDGs/Inverted/INVERTED SDG goals_icons-individual-cmyk-'+sdgData.bestScoredSdgPerCluster[index]+'.svg'">

					{{typeLabels[index]}}
				</div>
			</div>

		</div>

		<div v-if="visualExists" class="centered" style="position: relative">
			<img
					:src="baseUrl + stageData.visual"
					class="visual"
			/>
		</div>



	</div>

</template>


<script>
	import Vue from 'vue';
	import { mapGetters , mapActions } from 'vuex';
	import { url} from '../../const/base';
	import { api_url} from '../../const/base';
	import { lang } from '../../const/base';
	
	export default {

		data(){
			return{
				baseUrl : url,
				apiUrl : api_url,
				language : lang,
				headerReady: true,
				visualReady: true,
				storyReady: true,
				showPopup: '',
				popupRound: 0,
				typeLabels: {economy:'Economie',society:'Mens',biosphere:'Milieu'},
				sdgClusters:{society:[1,2,3,4,5,7,11,16], economy:[8,9,10,12], biosphere:[6,13,14,15]}
			}
		},

		beforeMount(){
			if(this.language == 'EN'){
				this.typeLabels = {economy:'Economy',society:'Society',biosphere:'Biosphere'}
			}
		},

		mounted(){

			setTimeout(()=>{
				this.setNextButtonAction(this.toNextStage).then(()=>{
					this.showNextButton({"btn":true , "btn-progres":true , "btn-progres-utrecht-whiteLine":false});
				});
			},500);
			
			this.showTransitorScore(true);

			this.initializeSDG();

			

		},

		methods:{
			...mapActions([
				"showNextButton",
				"hideNextButton",
				"setNextButtonAction",
				"toNextStage",
				"stopBlockTransition",
				"showTransitorScore",
				"saveAnswerLogs",
			]),

			initializeSDG(){

				console.log('sdgData');
				console.log(this.sdgData);

				let sendObj = {
					"user_id": this.userId,
					"instance_id" : this.instanceId,
					"sdgData" : this.sdgData
				};
				
				Vue.http.post(this.apiUrl + '/api/v2/savesdg' , sendObj).then(response => {


				}).catch(response => {
					//console.log("Error: ");
					//console.log(response);
				});

			},

		},

		computed: {

			visualExists(){
				return this.stageData != null && this.stageData.visual != null;
			},

			sdgData(){

				console.log('compute sdgData');

				let sdgObject = {};

				sdgObject.sdgCount = {};

				for(let i = 0 ; i < this.blocks.length ; i++){
					let block = this.blocks[i];


					if(block.settings == null || typeof block.settings.score === 'undefined') continue;
					else if(block.settings.score.use != "Yes") continue;


					for(let j = 0 ; j < block.data_structure.length ; j++){
						let stage = block.data_structure[j];
						if(stage.type != 'Rounds') continue;

						for(let k = 0 ; k < stage.data.rounds.length ; k++){

							let roundData = {questions:[]};
							let round = stage.data.rounds[k];

							console.log('round');
							console.log(round);


							if(round.questions.usescore != "Yes") continue;

							//combine all found sdg's to an array as key => count
							if(typeof round.sdgs !== 'undefined'){

								for (var l = 0; l < round.sdgs.length; l++) {
									
									let sdgIndex = round.sdgs[l];

									if(typeof sdgObject.sdgCount[sdgIndex] === 'undefined'){

										sdgObject.sdgCount[sdgIndex] = 1;

									}else{
										sdgObject.sdgCount[sdgIndex] += 1;
									}

								}

							}

						}

					}

				}

				//sdgClusters
				sdgObject.clusters = {};
				sdgObject.sdgCountPerCluster = {};

				for (let property in this.sdgClusters)
				{
					if (this.sdgClusters.hasOwnProperty(property)){

						let cluster = this.sdgClusters[property];
						let clusterCount = 0;

						sdgObject.sdgCountPerCluster[property] = {}

						for(let j = 0 ; j < cluster.length; j++){
							let sdgId = cluster[j];

							if(sdgObject.sdgCount[cluster[j]] > 0){
								clusterCount += sdgObject.sdgCount[cluster[j]];
								
								//add it to the sdgCountPerCluster object
								sdgObject.sdgCountPerCluster[property][cluster[j]] = sdgObject.sdgCount[cluster[j]];

							}
						}

						sdgObject.clusters[property] = clusterCount;
					}

				};



				//check the best scored SDG per cluster

				sdgObject.bestScoredSdgPerCluster = {};
				
				for (let property in sdgObject.sdgCountPerCluster)
				{
					if (sdgObject.sdgCountPerCluster.hasOwnProperty(property)){

						console.log('checking '+property);

						sdgObject.bestScoredSdgPerCluster[property] = 0;

						let highest = -1;
						for (let index in sdgObject.sdgCountPerCluster[property]){

							let sdgCount = sdgObject.sdgCountPerCluster[property][index];

							console.log(index+'->'+sdgCount);

							if(sdgCount>highest){
								highest = sdgCount;
								sdgObject.bestScoredSdgPerCluster[property] = index;
							}

						}



						
					}
				}

				return sdgObject;

			},

			...mapGetters([
				"globalSettings",
				"stageData",
				"lastStage",
				"blocks",
				"lastBlock",
				"transitorScore",
				"answerLogs",
				"instanceId",
				"userId",
				"userRole",
				"mbtiProfile",
				"challengeToken",
				"dcpProfileText"
			]),

			
			backgroundImage: function() {
				if(typeof this.stageData.background === 'undefined'){ 
					return 'none'
				}
		        return 'url('+ this.baseUrl + this.stageData.background + ')';
		    },
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/dcp/Sdg.vue